import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { AppService } from '@suite/app.service';
import { LanguageSettings } from '@suite/common/services/language-settings';
import { AssignmentRecord } from '@src/suite/playbook/data-models/records/assignment-record';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'icon',
    templateUrl: './icon.html',
    styleUrls: ['./icon.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-icon'
    }
})
export class Icon extends EnpsComponent  {
    @Input() public record: AssignmentRecord;

    protected predefinedAssignmentIconsMap: { [type: string]: { icon: string, color: string } } = {
        "GRAPHIC": { icon: "history_edu", color: "#f15a24" },
        "INTERACTIVE": { icon: "history_edu", color: "#c1272d" },
        "AUDIO": { icon: "history_edu", color: "#321911" },
        "LIVEVIDEO": { icon: "history_edu", color: "#662D91" },
        "TEXT": { icon: "history_edu", color: "#000000" },
        "PHOTO": { icon: "history_edu", color: "#006837" },
        "VIDEO": { icon: "history_edu", color: "#2e3192" },
        "SOCIALPROMOTION": { icon: "history_edu", color: "#0d47a1" },
        "SOCIAL": { icon: "history_edu", color: "#0d47a1" }
    }

    public title: string;
    private _type: string;
    @Input() public set type(v: string) {
        this._type = v;

        if (this._type) {
            if (this.languageSettings?.assignmentTypeTooltipMap[this._type.toUpperCase()]) {
                this.title = this.languageSettings?.assignmentTypeTooltipMap[this._type.toUpperCase()];
            } else {
                let title = this._type.toLowerCase();
                this.title = title.charAt(0).toUpperCase() + title.slice(1);
            }
        }
    }

    private _hasBorder = false;
    @Input()
    get hasBorder() {
        return this._hasBorder;
    }
    set hasBorder(req: BooleanInput) {
        this._hasBorder = coerceBooleanProperty(req);
    }

    get type(): string {
        return this.record?.coverageType || this._type;
    }

    get hasValue(): boolean {
        return !!this.record?.storyOwner?.length;
    }

    get icon(): string {
        return this.predefinedAssignmentIconsMap[this.type.toUpperCase()]?.icon;
    }

    constructor(
        public appService: AppService,
        private languageSettings: LanguageSettings,
        timeoutQueue: TimeoutQueue
    ) {
        super(timeoutQueue);
    }
}
